import { BaseUseCase } from "@domains/useCases/UseCaseBase";
class MFSipMandateUseCase extends BaseUseCase {
    constructor(Repo) {
        super();
        this.Repo = Repo;
    }
    async fetchResult() {
        return await this.Repo.getMfMandate();
    }
}
export default MFSipMandateUseCase;
